import { OutstandingCashItem } from "@common/contracts/reconciliation.contract";
import { createContext } from "react";

interface ReconciliationClearCashItemsContextValue {
    cashItemsByTransactionId: Map<number, OutstandingCashItem>;
    firstOutstandingTransactionId?: number;
}

export const ReconciliationClearCashItemsContext =
    createContext<ReconciliationClearCashItemsContextValue>({
        cashItemsByTransactionId: new Map(),
    });
